import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { CHAIN_NAMESPACES } from '@toruslabs/base-controllers';

const PLUGIN_NAMESPACES = _objectSpread(_objectSpread({}, CHAIN_NAMESPACES), {}, {
  MULTICHAIN: "multichain"
});
const PLUGIN_STATUS = {
  READY: "ready",
  CONNECTING: "connecting",
  CONNECTED: "connected",
  DISCONNECTED: "disconnected",
  ERRORED: "errored"
};
const PLUGIN_EVENTS = _objectSpread({}, PLUGIN_STATUS);
const EVM_PLUGINS = {
  WALLET_SERVICES: "wallet-services",
  NFT_CHECKOUT: "nft-checkout"
};
const SOLANA_PLUGINS = {
  SOLANA: "solana"
};
const WALLET_PLUGINS = _objectSpread(_objectSpread({}, EVM_PLUGINS), SOLANA_PLUGINS);

export { EVM_PLUGINS, PLUGIN_EVENTS, PLUGIN_NAMESPACES, PLUGIN_STATUS, SOLANA_PLUGINS, WALLET_PLUGINS };
